// /home/labdoo/zitech-nexus/frontend/src/pages/admin/AdminBlogPostsList.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { blogAPI } from '../../services/api';
import './AdminBlogManagement.css';

// SVG Icons
const Icons = {
  Plus: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M12 5V19M5 12H19" />
    </svg>
  ),
  View: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Edit: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3L21 7L7 21H3V17L17 3Z" />
    </svg>
  ),
  Delete: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7H20" />
      <path d="M10 11V16" />
      <path d="M14 11V16" />
      <path d="M5 7L6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19L19 7" />
      <path d="M9 7L10 3H14L15 7" />
    </svg>
  ),
  Publish: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 8V16M8 12H16" />
    </svg>
  ),
  Unpublish: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="8" y1="12" x2="16" y2="12" />
    </svg>
  ),
  Comments: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7443C15.6251 19.5894 14.0782 20.0573 12.5 20.1C11.1801 20.1034 9.87812 19.7951 8.7 19.2L3 21L4.8 15.3C4.2049 14.1219 3.89661 12.8199 3.9 11.5C3.94269 9.9218 4.4106 8.37486 5.25568 7.03248C6.10075 5.6901 7.28815 4.60554 8.7 3.9C9.87812 3.3049 11.1801 2.99661 12.5 3H13C15.0843 3.11499 17.053 3.99476 18.5291 5.47087C20.0052 6.94699 20.885 8.91568 21 11V11.5Z" />
    </svg>
  ),
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="abm-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  Empty: () => (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" />
      <path d="M22 6L12 13L2 6" />
    </svg>
  ),
  Calendar: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  User: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Category: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  ),
};

interface BlogPost {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  category_name: string;
  author_name: string;
  is_published: boolean;
  read_time: number;
  published_at: string;
  comments_count?: number;
  content?: string;
  image_url?: string;
}

const AdminBlogPostsList: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [filter, setFilter] = useState('all');
  const [previewPost, setPreviewPost] = useState<BlogPost | null>(null);
  const [previewLoading, setPreviewLoading] = useState(false);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await blogAPI.adminGetPosts();
      setPosts(response.data);
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      try {
        await blogAPI.adminDeletePost(id);
        fetchPosts();
      } catch (error) {
        console.error('Error deleting post:', error);
        alert('Failed to delete post');
      }
    }
  };

  const togglePublish = async (id: number, currentStatus: boolean) => {
    try {
      const formData = new FormData();
      formData.append('is_published', String(!currentStatus));
      await blogAPI.adminUpdatePost(id, formData);
      fetchPosts();
    } catch (error) {
      console.error('Error updating post status:', error);
      alert('Failed to update post status');
    }
  };

  const handlePreview = async (post: BlogPost) => {
    setPreviewLoading(true);
    setPreviewPost(post);
    
    // If content is not loaded, fetch full post details
    if (!post.content) {
      try {
        // Use adminGetPost to fetch single post with full content
        const response = await blogAPI.adminGetPost(post.id);
        const fullPost = response.data;
        if (fullPost) {
          setPreviewPost({ ...post, ...fullPost });
        }
      } catch (error) {
        console.error('Error fetching post content:', error);
      }
    }
    setPreviewLoading(false);
    document.body.style.overflow = 'hidden';
  };

  const closePreview = () => {
    setPreviewPost(null);
    document.body.style.overflow = 'auto';
  };

  // Handle Escape key to close preview
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && previewPost) {
        closePreview();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [previewPost]);

  const getStatusColor = (isPublished: boolean) => {
    return isPublished ? '#10b981' : '#f59e0b';
  };

  const getStatusBackground = (isPublished: boolean) => {
    return isPublished ? '#d1fae5' : '#fef3c7';
  };

  const filteredPosts = filter === 'all' 
    ? posts 
    : filter === 'published' 
      ? posts.filter(p => p.is_published)
      : posts.filter(p => !p.is_published);

  const counts = {
    all: posts.length,
    published: posts.filter(p => p.is_published).length,
    draft: posts.filter(p => !p.is_published).length,
  };

  if (loading) {
    return (
      <div className="abm-loading-container">
        <div className="abm-spinner">
          <Icons.Spinner />
        </div>
        <p className="abm-loading-text">Loading posts...</p>
      </div>
    );
  }

  return (
    <div className="abm-container">
      {/* Preview Modal */}
      {previewPost && (
        <div className="abm-preview-overlay" onClick={closePreview}>
          <div className="abm-preview-modal" onClick={(e) => e.stopPropagation()}>
            <div className="abm-preview-header">
              <h2 className="abm-preview-title">{previewPost.title}</h2>
              <button className="abm-preview-close" onClick={closePreview}>
                <Icons.Close />
              </button>
            </div>
            <div className="abm-preview-body">
              {previewLoading ? (
                <div className="abm-preview-loading">
                  <div className="abm-spinner-small"></div>
                  <p>Loading content...</p>
                </div>
              ) : (
                <>
                  {previewPost.image_url && (
                    <div className="abm-preview-image">
                      <img src={previewPost.image_url} alt={previewPost.title} />
                    </div>
                  )}
                  <div className="abm-preview-meta">
                    <span className="abm-preview-meta-item">
                      <Icons.User />
                      {previewPost.author_name}
                    </span>
                    <span className="abm-preview-meta-item">
                      <Icons.Category />
                      {previewPost.category_name}
                    </span>
                    <span className="abm-preview-meta-item">
                      <Icons.Calendar />
                      {new Date(previewPost.published_at).toLocaleDateString('en-US', { 
                        month: 'long', 
                        day: 'numeric', 
                        year: 'numeric' 
                      })}
                    </span>
                    <span className="abm-preview-meta-item">
                      {previewPost.read_time} min read
                    </span>
                  </div>
                  {previewPost.excerpt && (
                    <div className="abm-preview-excerpt">
                      {previewPost.excerpt}
                    </div>
                  )}
                  {previewPost.content && (
                    <div 
                      className="abm-preview-content"
                      dangerouslySetInnerHTML={{ __html: previewPost.content }}
                    />
                  )}
                  <div className="abm-preview-status">
                    <span 
                      className="abm-status-badge"
                      style={{
                        background: getStatusBackground(previewPost.is_published),
                        color: getStatusColor(previewPost.is_published)
                      }}
                    >
                      <span className="abm-status-dot" style={{ background: getStatusColor(previewPost.is_published) }}></span>
                      {previewPost.is_published ? 'Published' : 'Draft'}
                    </span>
                  </div>
                </>
              )}
            </div>
            <div className="abm-preview-footer">
              <button 
                className="abm-btn-secondary"
                onClick={() => window.open(`/blog/${previewPost.slug}`, '_blank')}
              >
                Open in New Tab
              </button>
              <button 
                className="abm-btn-primary"
                onClick={() => {
                  closePreview();
                  navigate(`/dashboard/admin/blog/posts/${previewPost.id}/edit`);
                }}
              >
                <Icons.Edit />
                Edit Post
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="abm-header">
        <div className="abm-header-left">
          <h1 className="abm-title">Blog Posts</h1>
          <p className="abm-subtitle">Manage your blog posts and track engagement</p>
        </div>
        <div className="abm-header-actions">
          <button 
            className="abm-btn-primary"
            onClick={() => navigate('/dashboard/admin/blog/posts/create')}
          >
            <Icons.Plus />
            Create New Post
          </button>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="abm-stats-bar">
        <div className="abm-stat-item">
          <span className="abm-stat-label">Total Posts</span>
          <span className="abm-stat-value">{counts.all}</span>
        </div>
        <div className="abm-stat-divider"></div>
        <div className="abm-stat-item">
          <span className="abm-stat-label">Published</span>
          <span className="abm-stat-value abm-stat-published">{counts.published}</span>
        </div>
        <div className="abm-stat-divider"></div>
        <div className="abm-stat-item">
          <span className="abm-stat-label">Drafts</span>
          <span className="abm-stat-value abm-stat-draft">{counts.draft}</span>
        </div>
      </div>

      {/* Filters */}
      <div className="abm-filter-bar">
        <button 
          className={`abm-filter-btn ${filter === 'all' ? 'abm-filter-active' : ''}`}
          onClick={() => setFilter('all')}
        >
          All
          <span className="abm-filter-count">{counts.all}</span>
        </button>
        <button 
          className={`abm-filter-btn ${filter === 'published' ? 'abm-filter-active' : ''}`}
          onClick={() => setFilter('published')}
        >
          Published
          <span className="abm-filter-count">{counts.published}</span>
        </button>
        <button 
          className={`abm-filter-btn ${filter === 'draft' ? 'abm-filter-active' : ''}`}
          onClick={() => setFilter('draft')}
        >
          Drafts
          <span className="abm-filter-count">{counts.draft}</span>
        </button>
      </div>

      {/* Table */}
      <div className="abm-table-wrapper">
        <table className="abm-table">
          <thead>
            <tr>
              <th className="abm-col-id">ID</th>
              <th className="abm-col-title">Title</th>
              <th className="abm-col-category">Category</th>
              <th className="abm-col-author">Author</th>
              <th className="abm-col-read">Read</th>
              <th className="abm-col-comments">Comments</th>
              <th className="abm-col-status">Status</th>
              <th className="abm-col-date">Published</th>
              <th className="abm-col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredPosts.length === 0 ? (
              <tr>
                <td colSpan={9} className="abm-empty-state">
                  <Icons.Empty />
                  <p className="abm-empty-text">No posts found</p>
                  <p className="abm-empty-subtext">Create your first blog post to get started</p>
                </td>
              </tr>
            ) : (
              filteredPosts.map((post) => (
                <tr key={post.id} className="abm-table-row">
                  <td className="abm-col-id">
                    <span className="abm-id-badge">#{post.id}</span>
                  </td>
                  <td className="abm-col-title">
                    <span className="abm-post-title">{post.title}</span>
                  </td>
                  <td className="abm-col-category">
                    <span className="abm-category">{post.category_name}</span>
                  </td>
                  <td className="abm-col-author">
                    <span className="abm-author">{post.author_name}</span>
                  </td>
                  <td className="abm-col-read">
                    <span className="abm-read-time">{post.read_time} min</span>
                  </td>
                  <td className="abm-col-comments">
                    <button 
                      className="abm-comments-link"
                      onClick={() => navigate(`/dashboard/admin/blog/comments?postId=${post.id}`)}
                      title="View Comments"
                    >
                      <Icons.Comments />
                      {post.comments_count || 0}
                    </button>
                  </td>
                  <td className="abm-col-status">
                    <span 
                      className="abm-status-badge"
                      style={{
                        background: getStatusBackground(post.is_published),
                        color: getStatusColor(post.is_published)
                      }}
                    >
                      <span className="abm-status-dot" style={{ background: getStatusColor(post.is_published) }}></span>
                      {post.is_published ? 'Published' : 'Draft'}
                    </span>
                  </td>
                  <td className="abm-col-date">
                    <span className="abm-date-text">
                      {new Date(post.published_at).toLocaleDateString('en-US', { 
                        month: 'short', 
                        day: 'numeric', 
                        year: 'numeric' 
                      })}
                    </span>
                  </td>
                  <td className="abm-col-actions">
                    <div className="abm-actions">
                      <button 
                        className="abm-action-btn abm-action-view"
                        onClick={() => handlePreview(post)}
                        title="Preview Post"
                      >
                        <Icons.View />
                      </button>
                      <button 
                        className="abm-action-btn abm-action-edit"
                        onClick={() => navigate(`/dashboard/admin/blog/posts/${post.id}/edit`)}
                        title="Edit Post"
                      >
                        <Icons.Edit />
                      </button>
                      <button 
                        className={`abm-action-btn ${post.is_published ? 'abm-action-unpublish' : 'abm-action-publish'}`}
                        onClick={() => togglePublish(post.id, post.is_published)}
                        title={post.is_published ? 'Unpublish' : 'Publish'}
                      >
                        {post.is_published ? <Icons.Unpublish /> : <Icons.Publish />}
                      </button>
                      <button 
                        className="abm-action-btn abm-action-delete"
                        onClick={() => handleDelete(post.id)}
                        title="Delete Post"
                      >
                        <Icons.Delete />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminBlogPostsList;